module.exports = __webpack_public_path__ + "static/media/logo-black-v.0e8dc6fe.svg";